import { DataBean } from "../DataBean";

export class EmployeeByFunctional extends DataBean {



    public async getEmployeeContractHistoryCatalogByFunctionalArea(idContract:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getEmployeeContractHistoryCatalogByFunctionalArea_Number", [idContract]);
    }

    public async getEmployeeContractsByFunctionalArea(idLnFunctionalArea:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getEmployeeContractsByFunctionalArea_Number_Number_Number", [idLnFunctionalArea,page,recordsPerPage]);
    }
    
}